import { render } from "./MagnifyingGlass.vue?vue&type=template&id=46db22ec"
import script from "./MagnifyingGlass.vue?vue&type=script&lang=js"
export * from "./MagnifyingGlass.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__